import _ from 'lodash';

// Why use this over the widespread "camelToSnakeCase" from es5 tools?
// - This will treat strings with number differently:
//   - es5 camelToSnakeCase: deliveryStreet1 => delivery_street1
//   - This method: deliveryStreet1 => delivery_street_1
function deepSnakeCaseKeys(obj: { [key: string]: any }) {
  if (_.isArray(obj)) {
    return obj.map(deepSnakeCaseKeys);
  } else if (_.isPlainObject(obj)) {
    return _.mapValues(
      _.mapKeys(obj, (value: any, key: any) =>
        key[0] === '_' ? key : _.snakeCase(key)
      ),
      deepSnakeCaseKeys
    );
  }
  return obj;
}

export default deepSnakeCaseKeys;
